import { render, staticRenderFns } from "./Keyword.vue?vue&type=template&id=413aaa76&scoped=true&"
import script from "./Keyword.vue?vue&type=script&lang=ts&"
export * from "./Keyword.vue?vue&type=script&lang=ts&"
import style0 from "./Keyword.vue?vue&type=style&index=0&id=413aaa76&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "413aaa76",
  null
  
)

export default component.exports